import { CSSProperties } from "react";

const style: { content: CSSProperties } = {
  content: {
    cursor: "text",
  },
};
export default style;
